import axios from 'utils/axiosInstance'

const BASE_URL_ENDPOINT = '/instrumentos/opcion_respuestas'

const getOpcionesRespuestas = async (busqueda = '') => {
  const response = await axios.get(`${BASE_URL_ENDPOINT}/?search=${busqueda}&ordering=id`)
  return response.data
}

const crearOpcionesRespuesta = async (values) => {
  const { data, onSuccess: onSuccessMessage } = await axios.post(
    `${BASE_URL_ENDPOINT}/`,
    values,
  )
  return { data, onSuccessMessage }
}

const eliminarOpcionesRespuesta = async ({ id, nombre }) => {
  const { onSuccess: onSuccessMessage } = await axios.delete(
    `${BASE_URL_ENDPOINT}/${id}`,
  )
  return { data: nombre, onSuccessMessage }
}

const actualizarOpcionesRespuesta = async ({ id, values }) => {
  const { data, onSuccess: onSuccessMessage } = await axios.put(
    `${BASE_URL_ENDPOINT}/${id}/`,
    values,
  )
  return { data, onSuccessMessage }
}

export {
  getOpcionesRespuestas,
  crearOpcionesRespuesta,
  eliminarOpcionesRespuesta,
  actualizarOpcionesRespuesta,
}